import React, { useEffect, useRef } from 'react';

const cleanInterval = (ref: React.MutableRefObject<ReturnType<typeof setInterval> | null>) => {
    if (ref.current !== null) {
        clearInterval(ref.current);
        // eslint-disable-next-line no-param-reassign
        ref.current = null;
    }
};

export const useRepeatableCallback = (callback: () => void, interval: number) => {
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        cleanInterval(intervalRef);

        intervalRef.current = setInterval(callback, interval);

        return () => cleanInterval(intervalRef);
    }, [callback, interval]);

    return { manualCallback: callback };
};
